<div class="line-chart" *ngIf="data">
  <div class="line-chart__axis-label" *ngIf="yLabel.length">{{yLabel}}</div>
  <div class="line-chart__canvas-wrapper">
    <canvas #chartEl></canvas>
  </div>
</div>
